<template>
  <transition name="modal">
    <div class="sef-modal-mask" v-if="show">
      <div class="card notif" style="width: 310px">
        <div class="card-header">
          <div class="card-title">
            <p style="margin-left: 4px">{{ title }}</p>
          </div>
          <div class="btn-actions-pane-right">
            <div class="btn-group-sm btn-group" role="group">
              <a
                href="#"
                class="active btn btn-focus"
                @click="doAction(false)"
              >
                <i class="scf-close"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="card-body-container">
            <div v-for="n in nbZones" :key="n" class="zone-container">
              <label style="flex: 0.3"
                >{{ $t("pages.Client.zone") }} {{ n }}*:
              </label>
              <input type="text" v-model="formData[n]" :disabled="fromPage == 'details'" />
            </div>
          </div>
        </div>
        <div class="modal-footer" v-if="['create', 'edit'].includes(fromPage)">
          <button
            type="button"
            class="btn btn-primary"
            @click="doAction(false)"
          >
            {{ $t("common.cancel") }}
          </button>
          <button
            type="button"
            :class="error ? 'disabledClass' : ''"
            class="btn btn-primary"
            @click="doAction(true)"
          >
            {{ $t("pages.Client.validate") }}
          </button>
        </div>
        <div
          v-else
          class="modal-footer"
          style="justify-content: center !important"
        >
          <button type="button" class="btn btn-primary" @click="close()">
            {{ $t("pages.Client.ok") }}
          </button>
        </div>
      </div>
          
    </div>
  </transition>
</template>

<script>
 
export default {
  name: "formModalZones",
  components: {},
  data() {
    return {
      modalShow: false,
      formData: {},
      InitformData: {},
      error: true,
      noData: true
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    nbZones: {
      required: false,
    },
    initialLevels: {
      required: false,
    },
    fromPage: {
      required: false,
      default: "create",
    },
  },

  mounted() {
    this.fillInitialFormData();
  },
  methods: {
    checkFieldsValidity() {
  let isValid = true;

  for (let index = 1; index <= this.nbZones; index++) {
    const val = this.formData[index];
    if (val === null || val === undefined || val.trim() === "") {
      isValid = false;
      break;
    }
  }

  this.error = !isValid;
  this.noData = !isValid;
}
,
    fillInitialFormData() {
     
      var result = [];
      if (this.initialLevels) {
        console.log("#######initialLevels:", this.initialLevels);
        for (let index = 1; index <= this.nbZones; index++) {
          result[index] = this.initialLevels[index - 1];
        }
        this.formData = result;
      }
    },
//   fillInitialFormData() {
//   const result = { ...this.formData }; // Clone de l’existant

//   for (let index = 1; index <= this.nbZones; index++) {
//     if (!result[index]) {
//       // Si initialLevels existe, utiliser sa valeur sinon mettre vide
//       result[index] = this.initialLevels?.[index - 1] || "";
//     }
//   }
  
//   this.formData = result;
// },
    doAction(isTrue) {
      if (isTrue === true) {
        console.log("valider - FormModalZone");
        //click on validate
        if (this.noData == true) {
          this.error = true;
       
        } else {
        const filledFieldsCount = Object.values(this.formData).filter(
  (val) => val !== null && val !== undefined && val !== ""
).length;
          if (filledFieldsCount !== this.nbZones) {
            this.error = true;
 
console.log("nbZones",this.nbZones);
console.log("Object.keys(this.formData).length",Object.keys(this.formData).length);

     
          } else {
            this.$emit("update:show", this.formData);
          }


//this.$emit("update:show", this.formData);
        //}
      // } else {
      //   //click on cancel
      //   this.fillInitialFormData();
       
         
      //     this.$emit("update:show", this.formData);
        }}else{
          this.fillInitialFormData();
           this.$emit("update:show", this.formData);
        }
    },
    close() {
        this.fillInitialFormData();
       this.$emit("update:show", this.formData);
     // this.$emit("update:show", this.formData);
    },
  },
  watch: {
    show: function (newValue) {
  this.modalShow = newValue;
  if (newValue === true) {
    console.log("opened");
       this.checkFieldsValidity(); // vérifie les champs à l’ouverture
  }
},
    // show: function (newValue) {
    //   this.modalShow = newValue;
    // },
    nbZones: function (newValue, oldValue) {
      if (newValue != oldValue) {
      //  this.formData = {};
      }
    },
    formData: {
      handler: function (newValue) {
        if (Object.keys(this.formData).length != this.nbZones) {
          this.error = true;
        } else {
          var error = false;
          for (const index in newValue) {
            if (newValue[index] == "") {
              error = true;
            }
          }

          if (error === true) {
            this.error = true;
            this.noData = true;
          } else {
            this.error = false;
            this.noData = false;
          }
        }
      },
  //       handler: function (newValue) {
  //   let hasError = false;

  //   // Vérifier qu’on a toutes les zones définies
  //   for (let index = 1; index <= this.nbZones; index++) {
  //     const val = newValue[index];
  //     if (val === undefined || val === null || val === "") {
  //       hasError = true;
  //       break;
  //     }
  //   }

  //   this.error = hasError;
  //   this.noData = hasError;
  // },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.disabledClass {
  cursor: inherit !important;
  color: #ccc !important;
}

.sef-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: 0.1 0.3s ease;
}

.card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: "D-DIN";
  width: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.card.full {
  width: 80%;
}

.card.notif .card-title {
  margin-right: 15px !important;
}

.card.notif .modal-footer {
  justify-content: center;
}

.card.confirmation {
  width: 30%;
}

.modal-footer .btn-primary {
  background-color: #eee !important;
  padding: 5px 30px;
  font-weight: bold;
  font-size: 14px;
  border: 1px solid #e2e6ec !important;
}

.card .card-header {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  border-bottom-width: 1px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
  padding-left: 10px;
  height: 35px;
  background-color: #bbdbfd;
  border-radius: 6px 6px 0px 0px;
  font-size: 12pt;
  font-weight: bold;
  border-bottom: 2px solid #1973d2;
  box-sizing: unset !important;
}
.card .card-header p {
  margin-top: revert !important;
  margin-bottom: revert !important;
}

.card-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0 !important;
}
.card .btn-actions-pane-right {
  margin-left: auto;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.card .card-header .btn-group,
.btn-group-vertical {
  position: relative;
  display: -ms-inline-flexbox;
  display: inline-flex;
  vertical-align: middle;
}
.card .card-header a {
  text-decoration: none;
}
.card .card-header a.btn.btn-focus i {
  /* margin-left: 10px;
        margin-right: 10px; */
  color: #1973d2;
  font-size: 12pt;
}
.card .card-header a.btn.btn-focus i:hover {
  opacity: 0.5;
}

.card-body {
  padding: unset !important;
}
.card .card-body-container {
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  overflow: hidden;
  overflow-y: auto;
  background: #f4f6fb;
  max-height: 680px;
  padding-bottom: 10px;
}

.card.full .card-body-container {
  height: 70vh;
}

.card .notif .card-body-container {
  height: auto;
}

.card.confirmation .card-body-container {
  height: 100px;
}

.card .modal-footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: space-between !important;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  background: #f4f6fb;
}
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s;
}

.btn-primary {
  color: #030f40;
  background-color: #eeeeee;
  border: 1px solid #030f40 !important;
}
.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.btn-primary:hover {
  color: #030f40;
  background-color: #dddddd;
  border-color: #030f40;
}

.modal-footer > :not(:last-child) {
  margin-right: 0.25rem;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}
.modal-information {
  font-weight: normal;
}

.zone-container {
  display: flex;
  margin: 10px 0px;
}

.zone-container input {
  margin-left: 10px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  border-radius: 4px !important;
  border: 1.5px solid #030f40 !important;
}
</style>
